<template>
  <div class="project-register-detail">
    <div class="detail-header">
      <div class="status-badge">
        <Tag :color="$common.projectRegisterStatusColor[projectModel.status]">
          {{$common.projectRegisterStatus[projectModel.status]}}
        </Tag>
      </div>
      <div class="order-number">
        <h2>
          {{projectModel.orderNumber}}
        </h2>
        <div class="font-grey">单据号:{{ projectModel.serialNo }}</div>
      </div>
      <div class="header-actions">
        <ButtonGroup>
          <Button type="default"
            @click="goModify"
            v-if="checkRolePermitted(['总承包'])&&[2,4].indexOf(projectModel.status)>=0"
            >
            <Icon type="md-create" />
            修改</Button>
          <Button type="default"
            @click="goModify"
            v-if="checkRolePermitted(['监管人','总监管人'])&&[0,4].indexOf(projectModel.status)>=0&&checkSpvMng('canModifyProjectRegister')"
            >
            <Icon type="md-create" />
            修改</Button>
          <Button type="default"
            @click="revoke"
            v-if="checkRolePermitted(['监管人','总监管人'])&&[0,1,4].indexOf(projectModel.status)>=0&&checkSpvMng('canRevokeProjectRegister')"
            >
            <Icon type="md-close" />
            撤销</Button>
          <Button type="default"
            @click="preAuditPass"
            v-if="checkRolePermitted(['监管人','总监管人'])&&projectModel.status===4&&checkSpvMng('canAddProjectRegister')"
            >
            <Icon type="md-checkmark" />
            预审同意</Button>
          <Button type="default"
            @click="perAuditDeny"
            v-if="checkRolePermitted(['监管人','总监管人'])&&projectModel.status===4&&checkSpvMng('canAddProjectRegister')"
            >
            <Icon type="md-close" />
            拒绝</Button>
          <Button type="default"
            @click="auditPass"
            v-if="checkRolePermitted(['监管人','总监管人'])&&projectModel.status===0&&checkSpvMng('canAuditProjectRegister')"
            >
            <Icon type="md-checkmark" />
            同意</Button>
          <Button type="default"
            @click="auditDeny"
            v-if="checkRolePermitted(['监管人','总监管人'])&&projectModel.status===0&&checkSpvMng('canAuditProjectRegister')"
            >
            <Icon type="md-close" />
            拒绝</Button>
          <Button type="default"
            v-if="checkRolePermitted(['监管人','总监管人','总承包'])&&projectModel.status===1"
            @click="downloadReceiptMulti">
            <Icon type="md-print" />
            下载《通知书》</Button>
          <!-- <Button type="default"
            @click="printPreview">
            <Icon type="md-print" />
            打印</Button> -->
          <Button type="default"
            @click="getDetail">
            <Icon type="md-refresh" />
            刷新</Button>
        </ButtonGroup>
      </div>
    </div>
    <table class="brief-table">
      <tbody>
        <tr>
          <td class="title">地区</td>
          <td>
            {{ projectModel.cityName }}
          </td>
          <td class="title">行业/领域</td>
          <td>
            {{ projectModel.industryName }}
          </td>
          <td class="title">保证金监管方</td>
          <td>
            {{ projectModel.supervisorName }}
          </td>
        </tr>
        <tr>
          <td class="title">项目名称</td>
          <td colspan="5">
            {{ projectModel.projectName }}
          </td>
        </tr>
        <tr>
          <td class="title">工程地址</td>
          <td colspan="3">
            {{ projectModel.projectSite }}
          </td>
          <td class="title">结构形式</td>
          <td>
            {{ projectModel.projectStruc }}
          </td>
        </tr>
        <tr>
          <td class="title">中标价(元)</td>
          <td>
            {{ projectModel.projectCost.toLocaleString() }}
            <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.projectCost)}}</div>
          </td>
          <td class="title">建设规模</td>
          <td>
            {{ projectModel.projectScale }}
          </td>
          <td class="title">开竣工日期(计划)</td>
          <td>
            {{ $moment(projectModel.projectStartDate).format('YYYY-MM-DD') }} 至 {{ $moment(projectModel.projectEndDate).format('YYYY-MM-DD') }}
          </td>
        </tr>
        <tr>
          <td class="title">建设单位名称</td>
          <td>
            {{ projectModel.ownerName }}
          </td>
          <td class="title">负责人</td>
          <td>
            {{ projectModel.ownerManager }}
          </td>
          <td class="title">联系电话</td>
          <td>
            {{ projectModel.ownerManagerTel }}
          </td>
        </tr>
        <tr>
          <td class="title">施工总包单位名称</td>
          <td>
            {{ projectModel.contractorName }}
          </td>
          <td class="title">项目经理</td>
          <td>
            {{ projectModel.contractorManager }}
          </td>
          <td class="title">联系电话</td>
          <td>
            {{ projectModel.contractorManagerTel }}
          </td>
        </tr>
        <tr>
          <td class="title">存储基数(元)</td>
          <td>
            {{ projectModel.payableBase.toLocaleString()  }}
            <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.payableBase)}}</div>
          </td>
          <td class="title">应存储金额(元)</td>
          <td>
            {{ projectModel.payableAmount.toLocaleString()  }}
            <div class="small font-grey">{{$common.transformNumberIntoCHS(projectModel.payableAmount)}}</div>
          </td>
          <td class="title">存储比例(%)</td>
          <td>
            {{ projectModel.payableRatio }}%
          </td>
        </tr>
        <tr>
          <td class="title">存储方式</td>
          <td>
            {{ projectModel.method ? '现金' : '保函' }}
          </td>
          <td class="title">保证金经办人</td>
          <td>
            {{ projectModel.opName }}
          </td>
          <td class="title">经办人电话</td>
          <td>
            {{ projectModel.opTel }}
          </td>
        </tr>
        <tr>
          <td class="title">经办机构名称</td>
          <td>
            {{ projectModel.guarantorName }}
          </td>
          <td class="title">联系人</td>
          <td>
            {{ projectModel.guarantorContact }}
          </td>
          <td class="title">电话</td>
          <td>
            {{ projectModel.guarantorTel }}
          </td>
        </tr>
        <tr>
          <td class="title">地址</td>
          <td colspan="5">
            {{ projectModel.guarantorAddress }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="padding-top-20"></div>
    <receipt-viewer :isShow="showReceiptViewer" :model="projectModel"></receipt-viewer>
  </div>
</template>

<script>
import Api from './../../../api/Api.js'
// import PrintPreviewer from './../../components/PrintPreviewer.vue'
import ReceiptViewer from './ReceiptView.vue'
import ExportSavePdf from '@/utils/html2pdf'
import ExportSavePdfMulti from '@/utils/html2pdfMulti'
export default {
  name: 'project-register-detail',
  props: {
    projectModel: {
      type: Object,
      default: () => {
        return {
          industryId: null,
          cityId: null,
          method: 0, // 存储方式：0-保函|1-现金
          projectName: null,
          projectSite: null,
          projectStruc: null,
          projectScale: null,
          projectCost: 0,
          projectStartDate: null,
          projectEndDate: null,
          daterange: null,
          duration: null,
          ownerName: null,
          ownerManager: null,
          ownerManagerTel: null,
          contractorName: null,
          contractorManager: null,
          contractorManagerTel: null,
          payableBase: 0,
          payableAmount: 0,
          payableRatio: 2,
          opName: null,
          opTel: null,
          status: null,
          supervisorName: null,
          guarantorName: null,
          guarantorAddress: null,
          guarantorContact: null,
          guarantorTel: null,
        }
      }
    }
  },
  components: {
    // PrintPreviewer,
    ReceiptViewer
  },
  data () {
    return {
      loading: false,
      html: null,
      showPrintPreviewer: false,
      showReceiptViewer: false,
      supvPerms: {
        canAudit: false,
        canPreAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false
      },
      auditModel: {
        reason: null
      },
      dataToSign: null
    }
  },
  watch: {
  },
  mounted () {
    this.getSupervisionPermission()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    closePrintPreviewer () {
      this.html = null
      this.showPrintPreviewer = false
    },
    printPreview () {
      this.showReceiptViewer = true
      this.$nextTick(() => {
        this.html = document.getElementById('printArea').outerHTML
        this.showPrintPreviewer = true
        this.$nextTick(() => {
          this.showReceiptViewer = false
        })
      })
    },
    async downloadReceiptMulti () {
      this.showReceiptViewer = true
      this.$nextTick(async () => {
        this.loading = true
        this.$Spin.show()
        await ExportSavePdfMulti(
          ['printArea-0', 'printArea-1', 'printArea-2'],
          '保证金存储通知书',
          this.$moment().format('YYYY-MM-DD'),
          'landscape'
        )
        .then(() => {
          this.showReceiptViewer = false
          this.loading = false
          this.$Spin.hide()
        })
      })
    },
    downloadReceipt () {
      ExportSavePdf('printArea', '保证金存储通知书', this.$moment().format('YYYY-MM-DD'), 'landscape')
    },
    projectCostChange (val) {
      this.projectModel.payableBase = val
      this.calcPayableAmount()
    },
    calcPayableAmount () {
      this.projectModel.payableAmount = Math.round(this.projectModel.payableRatio * this.projectModel.payableBase) / 100
    },
    calcPayableRatio () {
      this.projectModel.payableRatio = Math.round(this.projectModel.payableAmount / this.projectModel.payableBase * 10000) / 100
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    checkSpvMng (action) {
      if (this.$store.getters.userInfo && this.$store.getters.userInfo.type === 127) {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '总监管人') {
        return true
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '监管人') {
        // return this.getSysConfig('ENABLE_SUPV_MNG_GUA')
        // console.log(this.supvPerms[action])
        if (action == 'canModifyProjectRegister') {
          return this.projectModel.createUserId === this.$store.getters.userInfo.id
        }
        if (action == 'canRevokeProjectRegister') {
          return this.projectModel.createUserId === this.$store.getters.userInfo.id
        }
        return this.supvPerms[action]
      }
      return false
    },
    async getSupervisionPermission () {
      await this.$Api.ProjectRegister.getSupervisionPermissions(this.$route.params.orderNumber)
      .then((res) => {
        // console.log(res)
        Object.assign(this.supvPerms, res)
      })
      .catch(() => {
        this.supvPerms = {
          canAudit: false,
          canPreAudit: false,
          canAuditTerminate: false,
          canAuditRenewal: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false
        }
      })
    },
    preAuditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认预审通过该申请么？</p>',
        onOk: async () => {
          this.loading = true
          this.dataToSign = {
            orderNumber: this.$route.params.orderNumber,
            pass: true,
            reason: null
          }
          this.doPreAudit(true)
        }
      })
    },
    preAuditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认拒绝该申请么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写退回的原因',
                  type: 'textarea',
                  autosize: {minRows: 5, maxRows: 10},
                  rows: 5
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          this.dataToSign = {
            orderNumber: this.$route.params.orderNumber,
            pass: false,
            reason: this.auditModel.reason
          }
          this.doPreAudit(false)
        }
      })
    },
    async doPreAudit (pass) {
      await this.$Api.ProjectRegister.preAuditProjectRegister(this.$route.params.orderNumber, pass)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    auditPass () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认同意该申请么？</p>',
        onOk: async () => {
          this.loading = true
          this.dataToSign = {
            orderNumber: this.$route.params.orderNumber,
            pass: true,
            reason: null
          }
          this.doAudit(true)
        }
      })
    },
    auditDeny () {
      this.$Modal.confirm({
        title: '确认操作',
        render: (h) => {
          return h('div', {}, [
            h('p', {}, '确认拒绝该申请么？请填写原因后提交'),
            h('Input', {
                props: {
                  value: this.auditModel.reason,
                  autofocus: true,
                  placeholder: '填写退回的原因',
                  type: 'textarea',
                  autosize: {minRows: 5, maxRows: 10},
                  rows: 5
                },
                on: {
                  input: (val) => {
                    this.auditModel.reason = val
                  }
                }
              }
            )
          ])
        },
        onOk: async () => {
          if (!this.auditModel.reason) {
            this.$Notice.error({
              title: '操作失败!',
              desc: '请填写退回原因'
            })
            return false
          }
          this.loading = true
          this.dataToSign = {
            orderNumber: this.$route.params.orderNumber,
            pass: false,
            reason: this.auditModel.reason
          }
          this.doAudit(false)
        }
      })
    },
    async doAudit (pass) {
      await this.$Api.ProjectRegister.auditProjectRegister(this.$route.params.orderNumber, pass)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    revoke () {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认撤销该申请么？</p>',
        onOk: async () => {
          this.loading = true
          this.doRevoke()
        }
      })
    },
    async doRevoke () {
      await Api.ProjectRegister.revokeProjectRegister(this.$route.params.orderNumber)
      .then(() => {
        // console.log(payload)
        this.$Message.success('操作成功!')
        this.loading = false
        this.$Spin.hide()
        this.getDetail()
      })
      .catch(err => {
        this.loading = false
        this.$Spin.hide()
        this.$Notice.error({
          title: '操作失败!',
          desc: err.message
        })
      })
    },
    goModify () {
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (userRole === '总承包') {
        this.$router.push({name: 'project-register-edit-by-contractor', params: {orderNumber: this.$route.params.orderNumber}})
      } else {
        this.$router.push({name: 'project-register-edit', params: {orderNumber: this.$route.params.orderNumber}})
      }
    },
    async getDetail () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        this.$Api.ProjectRegister.getProjectRegisterDetail(this.$route.params.orderNumber)
          .then((payload) => {
            payload.payableRatio = Math.round(payload.payableRatio * 100 * 100) / 100
            payload.payableAmount = Math.round(payload.payableAmount / 100)
            payload.payableBase /= 100
            payload.projectCost /= 100
            this.projectModel = payload
            this.loading = false
            this.$Spin.hide()
            resolve(this.projectModel)
          })
          .catch(err => {
            console.log('err', err)
            this.$Message.error('载入失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
            reject(err)
          })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.project-register-detail {
  .detail-header {
    margin-bottom: 20px;
    position: relative;
    .status-badge {
      position: absolute;
      right: 0;
      top: 0;
    }
    .header-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
